import React from 'react'
import Aux from '../../../../../../hoc/Auxiliary/Auxiliary'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core/'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import _ from 'lodash'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  header: {
    cursor: 'pointer',
    '&:hover': {
      // backgroundColor: '#DDDDDD',
      textDecoration: 'underline'
    }
  }
})

function ComparisonTable(props) {
  const classes = useStyles()
  const {
    appraisal_type_id,
    company_id,
    emp_id,
    form_id,
    level_group_id,
    org_id,
    position_id,
    structure_id
  } = props.filterControls

  return (
    <Aux>
      {_.size(props.tableData) > 0 ? (
        <TableContainer>
          <Table stickyHeader size='small'>
            <TableHead>
              <TableRow hover>
                <TableCell />
                {Object.keys(props.tableData.avg_line.data).map((row, index) => (
                  <TableCell key={index} align='center'>
                    <div
                      className={classes.header}
                      onClick={() => {
                        // alert(JSON.stringify(row))
                        let year = JSON.stringify(JSON.parse(Object.values({ row })), null, 2)
                        let param = {
                          appraisal_type_id: appraisal_type_id?.value?.value,
                          form_id: form_id?.value?.value,
                          org_id: org_id?.value?.value,
                          company_id: company_id?.value?.value,
                          structure_id: structure_id?.value?.value,
                          year: year,
                          emp_id: emp_id?.value?.value,
                          position_id: position_id?.value?.value,
                          level_group_id: level_group_id?.value?.value
                        }
                        props.getYear(year)
                        props.fetchDashboardPerformanceComparisonChartBar(param)
                      }}>
                      {row}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.values(props.tableData).map((row, index) => (
                <TableRow key={index} hover>
                  <TableCell align='right'>{row.label}</TableCell>
                  {Object.values(row.data).map(cell => (
                    <TableCell align='center'>{cell}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}
    </Aux>
  )
}

export default withTranslate(ComparisonTable)
